/* eslint-disable */

<template>

  <div class="profile-panel">
    <div class="profile-container">
      <image-input v-model="avatar">
        <div slot="activator">
          <img id="profile-img" class="profile-img-card" :src="computedProfileImage" v-bind:style="{'border-radius': avatar ? '100px' : ''}" v-tooltip="'Avatar ändern'" style="cursor: pointer"/>
        </div>

      </image-input>
      <div v-if="avatar && savedImage == false" class="footer no-divider" style="position: absolute; margin-top: -50px;">
        <div class="align-left">
          <buttonc type="footer green " label="Profilbild speichern"  @click="changeProfileImage()"/>
        </div>
      </div>
      <p id="profile-name" class="profile-name-card">{{firstname}} {{lastname}}</p>
      <div class="profile-user-info">
        <div class="entry divider">
          <div class="line-through"></div>
        </div>
        <div class="entry">
          <labelc text="E-Mail" v-bind:style="{width: labelWidth + 'px'}"/>
          <labelc type="data" :text="email"/>
          <buttonc type="edit no-hover icon-green-hover" icon="fa-pencil-square" @click="OpenChangeEmailPopup()"/>
        </div>
        <div class="entry">
          <labelc :text="$t('employee.core.firstName')" v-bind:style="{width: labelWidth + 'px'}"/>
          <labelc type="data" :text="firstname"/>
          <buttonc type="edit no-hover icon-green-hover" icon="fa-pencil-square" @click="OpenChangeFirstNamePopup()"/>
        </div>
        <div class="entry">
          <labelc :text="$t('employee.core.lastName')" v-bind:style="{width: labelWidth + 'px'}"/>
          <labelc type="data" :text="lastname"/>
          <buttonc type="edit no-hover icon-green-hover" icon="fa-pencil-square" @click="OpenChangeLastNamePopup()"/>
        </div>
        <div class="entry" v-if="twofactor && !isBlank(telephone)">
          <labelc :text="$t('employee.core.phone')" v-bind:style="{width: labelWidth + 'px'}"/>
          <labelc type="data" :text="telephone"/>
          <buttonc type="edit no-hover icon-green-hover" icon="fa-pencil-square" />
        </div>
        <div class="entry">
          <labelc :text="$t('comp.view.password')" v-bind:style="{width: labelWidth + 'px'}"/>
          <labelc type="data" text="**********"/>
          <buttonc type="edit no-hover icon-green-hover" icon="fa-pencil-square" @click="OpenChangePasswordPopup()"/>
        </div>
        <div class="entry">
          <labelc text="2F Auth" v-bind:style="{width: labelWidth + 'px'}"/>
          <labelc type="data" :text="twofactor ? 'Aktiviert' : 'Deaktiviert'"/>
          <buttonc type="edit no-hover icon-green-hover" :icon="twofactor ? 'fa-check green' : 'fa-circle'" @click="Toggle2Factor()" style="margin-right: -2px;"/>
        </div>
        <div class="entry" v-if="isAdmin">
          <buttonc type="edit no-hover icon-green-hover" :label="$t('comp.ui.goToUserOverview')"  @click="RouterToOverview()" style="width: 90px;"/>
        </div>
      </div>
      <div class="link-container">
        <img src="../../assets/serviceimg/mp.png" class="mp" @click="window.open('https://www.meinplayer.at', '_blank')"/>
        <img src="../../assets/serviceimg/mz.png" @click="window.open('https://www.meinezeiterfassung.at', '_blank')"/>
        <img src="../../assets/serviceimg/md.png" @click="window.open('https://web.meindienstplan.at', '_blank')"/>
      </div>
      <div class="footer">
        <div class="align-left" style="justify-content: center !important;">
          <buttonc type="footer dark" :label="$t('employee.insure.deregister')"  @click="logout()"/>
        </div>
        <!--<div class="align-right"></div>-->
      </div>
    </div><!-- /card-container -->
  </div><!-- /container -->
</template>

<script>
    import axios from 'axios';
    import VueQr from 'vue-qr';
    import ImageInput from '@/components/ImageInput.vue'
    export default {
        name: 'profilepanel',
        data () {
            return {
                id: 0,
                email:"",
                newemail:"",
                profileimage:"",
                firstname: "",
                newfirstname:"",
                lastname: "",
                newlastname:"",
                telephone: "",
                token:"",
                password:"",
                newpassword:"",
                twofactor: false,
                isAdmin: false,
                avatar: null,
                twofactorConfirm: null,
                totpuri: "",
                savedImage: false,
                twofactortype: "NONE",
                temptwofactortype: "GAUTH",
                labelWidth: 120,
                window: window,
            }
        },
        created: function () {
            this.id = this.$route.params.id;
            this.token = localStorage.getItem('md_token')
            if(this.isBlank(this.token)){
                this.returnToIndex();
            } else {
                let claims = this.extractJWTInfo(this.token);
                if(claims.role === 'ADMIN'){
                    this.isAdmin = true;
                }
                this.loadProfile();
            }
        },
        components: {
            ImageInput: ImageInput,
            VueQr
        },
        // methods that implement data logic.
        methods : {
            isBlank: function (str) {
                return (!str || /^\s*$/.test(str));
            },
            getQueryStringValue: function (key) {
                return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
            },
            extractJWTInfo: function(token){
                if (token) return JSON.parse(atob(token.split('.')[1]));
                return {};

            },
            loadProfile : function() {
                let view = this;
                axios({
                    method: 'get',
                    url: '/api/user?id='+this.id,
                    headers: {'Authorization': 'Bearer ' + this.token}
                }).then(response => {
                    this.firstname = response.data.firstname;
                    this.lastname = response.data.lastname;
                    this.profileimage = response.data.profileimage;
                    this.email = response.data.email;
                    this.telephone = response.data.telephone;
                    this.twofactor = response.data.twofactor;
                    this.twofactortype = response.data.twofactortype;
                }).catch(function (error) {
                    if(error.response != undefined && error.response.data.message != undefined){
                        view.toggleModal(view.$t('employee.data.error'),
                            `<p>${view.$t('comp.ui.userDataLoadFailed')}</p><p>${view.$t(
                                'comp.ui.tryAgainOrContactAdmin')}</p>`
                        );
                    }
                })

            },
            changeProfileImage: function(){
                let view = this;
                var payload = {
                    command: "updateProfileImage",
                    id: this.id,
                    profileimage: this.avatar.imageURL
                }
                let formData = this.avatar.formData;
                formData.set("id", this.id)
                axios.post('/api/profileimage', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': 'Bearer ' + this.token
                    }
                }).then(response => {
                    view.profileimage = view.avatar.imageURL;
                    view.savedImage = true;
                }).catch(function (error) {
                    if(error.response != undefined && error.response.data.message != undefined){
                        view.toggleModal(view.$t('employee.data.error'), '<p>' + view.$t('comp.ui.changeNotPossible') + '</p><p>' + view.$t('comp.ui.tryAgainOrContactAdmin') + '</p>');
                    }
                })
            },
            changeFirstName: function(firstname){
                let view = this;
                var payload = {
                    command: "updateFirstName",
                    id: this.id,
                    firstname: firstname
                }
                return axios({
                    method: 'put',
                    url: '/api/user',
                    headers: {'Authorization': 'Bearer ' + this.token},
                    data: payload
                })
            },
            changeLastName: function(lastname){
                let view = this;
                var payload = {
                    command: "updateLastName",
                    id: this.id,
                    lastname: lastname
                }
                return axios({
                    method: 'put',
                    url: '/api/user',
                    headers: {'Authorization': 'Bearer ' + this.token},
                    data: payload
                })
            },
            changeEmail: function(newEmail, password){
                let view = this;
                var payload = {
                    command: "updateEmail",
                    id: this.id,
                    email: newEmail,
                    password: password
                }
                return axios({
                    method: 'put',
                    url: '/api/user',
                    headers: {'Authorization': 'Bearer ' + this.token},
                    data: payload
                })

                    /*.then(response => {
                    view.email = view.newemail
                    view.$modal.hide('changeEmailModal');
                    view.newemail = "";
                    view.password = "";
                }).catch(function (error) {
                    view.newemail = "";
                    view.password = "";
                    view.$modal.hide('changeEmailModal');
                    if(error.response != undefined && error.response.data.message != undefined){
                        view.toggleModal('Fehler', '<p>Änderung konnte nicht durchgeführt werden.</p><p>Bitte versuchen Sie es erneut oder kontaktieren Sie einen Administrator.</p>');
                    }
                })*/
            },
            changePassword: function(password, newpassword){
                let view = this;
                var payload = {
                    command: "updatePassword",
                    id: this.id,
                    newpassword: newpassword,
                    password: password
                }
                return axios({
                    method: 'put',
                    url: '/api/user',
                    headers: {'Authorization': 'Bearer ' + this.token},
                    data: payload
                })
            },
            requestTwoFactor: function (type ) {
                this.hideCustomModal('chooseTwoFactor');
                var payload = {
                    command: "requestTwoFactor",
                    id: this.id
                }
                if (type === 'EMAIL'){
                    payload.command = "requestEmailTwoFactor";
                }

                let token = localStorage.getItem('md_token')
                let view = this;
                return axios({
                    method: 'put',
                    url: '/api/user',
                    headers: {'Authorization': 'Bearer ' + token},
                    data: payload
                })
            },
            activateTwoFactor: function (twofactorcode) {

                var payload = {
                    command: "activateTwoFactor",
                    id: this.id,
                    password: twofactorcode
                }
                let token = localStorage.getItem('md_token')
                let view = this;
                return axios({
                    method: 'put',
                    url: '/api/user',
                    headers: {'Authorization': 'Bearer ' + token},
                    data: payload
                })
            },
            SendDeactivateTwoFactorEmail: function() {
                  let token = localStorage.getItem('md_token')
                  var payload = {
                      command: "requestEmailCode",
                      id: this.id
                  }
                  return axios({
                      method: 'put',
                      url: '/api/user',
                      headers: {'Authorization': 'Bearer ' + token},
                      data: payload
                  });
            },
            deactivateTwoFactor: function (twofactorcode) {

                var payload = {
                    command: "deactivateTwoFactor",
                    id: this.id,
                    password: twofactorcode
                }
                let token = localStorage.getItem('md_token');
                let view = this;
                return axios({
                    method: 'put',
                    url: '/api/user',
                    headers: {'Authorization': 'Bearer ' + token},
                    data: payload
                })
            },
            logout: function(){
                localStorage.removeItem("md_token");
                this.returnToIndex();
                this.$parent.state.locked = false;
                this.$parent.state.toggled = false;
            },
            returnToIndex: function(){
                this.$router.replace('/');
            },
            showCustomModal: function(modal){
                this.$modal.show(modal);
            },
            OpenChangeFirstNamePopup(){
                let view = this;
                this.$helpers.OpenPopup({
                    header: view.$t('comp.ui.changeFirstName'),
                    width: '600px',
                    components: [{
                        type: 'datafill',
                        state: {
                            entries: [{key: 'firstname', type: 'text', value: this.firstname, label:view.$t('comp.ui.newFirstName')}],
                            selectCallback: (data, datafill) => {
                                datafill.loading = true;
                                view.changeFirstName(data.firstname).then((response) => {
                                    view.firstname = data.firstname;
                                    datafill.Toggle();
                                }).catch((error) => {
                                    datafill.loading = false;
                                    if (error.response != undefined && error.response.data.message != undefined) {
                                        datafill.errors = {};
                                        datafill.errors['firstname'] = {
                                            key: 'firstname',
                                            type: 'error',
                                            text: view.$t('global.ui.changeNotPossible'),
                                            tooltip: view.$t('global.ui.tryAgainOrContactAdmin')
                                        };
                                    }
                                })
                            },
                        },
                    }],
                    centered: true,

                });
            },
            OpenChangeLastNamePopup(){
                let view = this;
                this.$helpers.OpenPopup({
                    header: view.$t('comp.ui.changeLastName'),
                    width: '600px',
                    components: [{
                        type: 'datafill',
                        state: {
                            entries: [{key: 'lastname', type: 'text', value: this.lastname, label: view.$t('comp.ui.newLastName')}],
                            selectCallback: (data, datafill) => {
                                datafill.loading = true;
                                view.changeLastName(data.lastname).then((response) => {
                                view.lastname = data.lastname;
                                datafill.Toggle();
                              }).catch((error) => {
                                  datafill.loading = false;
                                  if(error.response != undefined && error.response.data.message != undefined){
                                      datafill.errors = {};
                                      datafill.errors['lastname'] = {key: 'lastname', type: 'error', text: view.$t('global.ui.changeNotPossible'), tooltip: view.$t('global.ui.tryAgainOrContactAdmin')};
                                  }
                              })
                            },
                        },
                    }],
                    centered: true,

                });
            },
            OpenChangePasswordPopup(){
                let view = this;
                this.$helpers.OpenPopup({
                    header: this.$t('comp.ui.changePassword'),
                    width: '600px',
                    components: [{
                        type: 'datafill',
                        state: {
                              descriptionSub: this.$t('comp.ui.passwordChangeInfo'),
                            entries: [
                                {
                                    key: 'password', type: 'password', value: '', label: this.$t('comp.ui.oldPassword')
                                },
                                {
                                    key: 'newpassword',
                                    type: 'password',
                                    value: '',
                                    label: this.$t('comp.ui.newPassword')
                                },
                                {
                                    key: 'newpasswordconfirm',
                                    type: 'password',
                                    value: '',
                                    label: this.$t('comp.ui.repeatPassword')
                                }
                            ],
                            errorCheck: [
                                (entries) => {
                                    if(entries.hasOwnProperty('newpassword') && entries.hasOwnProperty('newpasswordconfirm') && entries['newpassword'] !== entries['newpasswordconfirm']) return {key: 'newpassword', type: 'error', text: this.$t('comp.ui.passwordsDoNotMatch')}
                                    else return null;
                                },
                                (entries) => {
                                    if(entries.hasOwnProperty('newpassword') && entries.hasOwnProperty('newpasswordconfirm') && entries['newpassword'] !== entries['newpasswordconfirm']) return {key: 'newpasswordconfirm', type: 'error', text: this.$t('comp.ui.passwordsDoNotMatch')}
                                    else return null;
                                },
                            ],
                            selectCallback: (data, datafill) => {
                                datafill.loading = true;
                                view.changePassword(data.password, data.newpassword).then((response) => {
                                    //view.lastname = data.lastname;
                                    datafill.Toggle();
                                }).catch((error) => {
                                    datafill.loading = false;
                                    if(error.response != undefined && error.response.data.message != undefined){
                                        datafill.errors = {};
                                        datafill.errors['password'] = {key: 'password', type: 'error', text: view.$t('global.ui.changeNotPossible'), tooltip: view.$t('global.ui.tryAgainOrContactAdmin')};
                                        datafill.errors['newpassword'] = {key: 'password', type: 'error', text: view.$t('global.ui.changeNotPossible'), tooltip: view.$t('global.ui.tryAgainOrContactAdmin')};
                                        datafill.errors['newpasswordconfirm'] = {key: 'password', type: 'error', text: view.$t('global.ui.changeNotPossible'), tooltip: view.$t('global.ui.tryAgainOrContactAdmin')};
                                    }
                                })
                            },
                        },
                    }],
                    centered: true,
                });
            },
            OpenChangeEmailPopup(){
                let view = this;
                this.$helpers.OpenPopup({
                    header: this.$t('comp.ui.changeEmail'),
                    width: '600px',
                    components: [{
                        type: 'datafill',
                        state: {
                            descriptionSub: this.$t('comp.ui.changeEmailInfo'),
                            entries: [
                                {key: 'email', type: 'text', value: '', label:this.$t('comp.ui.newEmail') },
                                {key: 'password', type: 'password', value: '', label:this.$t('comp.ui.password')}],
                            errorCheck: [
                                (entries) => {
                                    if(entries.hasOwnProperty('password') && entries.password === '') return {key: 'password', type: 'error', text: this.$t('comp.ui.enterPassword')}
                                    else return null;
                                },
                                (entries) => {
                                  if(!view.$helpers.ValidEmailCheck(entries['email'])) return {key: 'email', type: 'error', text: this.$t('comp.ui.wrongEmail')}
                                  else return null;
                              },
                            ],
                            selectCallback: (data, datafill) => {
                                datafill.loading = true;
                                view.changeEmail(data.email, data.password).then((response) => {
                                    view.email = data.email;
                                    datafill.Toggle();
                                }).catch((error) => {
                                    datafill.loading = false;
                                    if(error.response != undefined && error.response.data.message != undefined){
                                        datafill.errors = {};
                                        datafill.errors['password'] = {key: 'password', type: 'error', text: view.$t('global.ui.changeNotPossible'), tooltip: view.$t('global.ui.tryAgainOrContactAdmin')};
                                        //view.toggleModal('Fehler', '<p>Änderung konnte nicht durchgeführt werden.</p><p>Bitte versuchen Sie es erneut oder kontaktieren Sie einen Administrator.</p>');
                                    }
                                })
                            },
                        },
                    }],
                    centered: true,
                });
            },
            hideCustomModal: function(modal){
                this.$modal.hide(modal);
            },
            toggleModal(title, text, text2) {
                this.$helpers.OpenInfoPopup(title, [text, text2]);
            },
            Toggle2Factor(){
                if(this.twofactor){
                    if(this.twofactor && this.twofactortype === 'EMAIL'){
                        this.SendDeactivateTwoFactorEmail().then(response => {
                            this.OpenDeactivate2FPopup();
                        }).catch(error => {
                            this.toggleModal(this.$t('employee.data.error'),
                                `<p>${this.$t('comp.ui.twoFactorActivationFailed')}</p><p>${this.$t(
                                    'comp.ui.tryAgainOrContactAdmin')}</p>`
                            );
                        })
                    } else {
                        this.OpenDeactivate2FPopup();
                    }
                } else {
                    this.OpenChoose2FPopup();
                }
            },
            OpenChoose2FPopup(){
                let view = this;
                this.$helpers.OpenPopup({
                    header: this.$t('comp.ui.twoFactorOption'),
                    width: '600px',
                    components: [{
                        type: 'datafill',
                        state: {
                            descriptionSub: this.$t('comp.ui.chooseTwoFactorMethod'),
                            entries: [
                                {key: 'twofactortype', type: 'bool', value: true, valueFixed: true, label:this.$t('comp.ui.authenticatorApp')}],
                            selectCallback: (data, datafill) => {
                                datafill.loading = true;
                                view.requestTwoFactor(data.twofactortype ? 'GAUTH' : 'EMAIL').then(response => {
                                    datafill.Toggle();
                                    view.totpuri = response.data.totpuri;
                                    view.OpenActivate2FPopup();
                                }).catch(function (error) {
                                    datafill.loading = false;
                                    if(error.response != undefined && error.response.data.message != undefined){
                                        view.toggleModal(view.$t('employee.data.error'),
                                            `<p>${view.$t('comp.ui.twoFactorActivationFailed')}</p><p>${view.$t(
                                                'comp.ui.tryAgainOrContactAdmin')}</p>`
                                        );
                                    }
                                })
                            },
                        },
                    }],
                    centered: true,
                });
            },
            OpenActivate2FPopup(){
                let view = this;
                this.$helpers.OpenPopup({
                    header: this.$t('comp.ui.activate2f'),
                    width: '600px',
                    components: [{
                        type: 'datafill',
                        state: {
                            descriptionSub: this.$t('comp.ui.activate2fDescription'),
                            entries: [
                                {key: 'qrcode', type: 'qrcode', value: view.totpuri, label:'', styles: {height: '300px'}},
                                {key: 'twofactorcode', type: 'passwordsplit', value: '', length: 6, placeholder:this.$t('comp.ui.twoFactorCode'), label: '', styles: {'margin-top': '-20px !important'}}],
                            positiveButtonStyle: {
                                position: 'absolute',
                                right: '60px',
                                'margin-top': '00px !important'},
                            selectCallback: (data, datafill) => {
                                datafill.loading = true;
                                view.activateTwoFactor(data.twofactorcode).then(response => {
                                    let backupCodes = response.data.backup;
                                    let text =
                                        `<p>${this.$t('comp.ui.twoFactorActivated')}</p>` +
                                        `<p>${this.$t('comp.ui.backupCodesIntro')}</p><ul>`;
                                    for (const i of backupCodes) {
                                        text = text+'<li style="margin-left: 30px">'+i+'</li>'
                                    }
                                    text = text +
                                        `</ul><p>${this.$t('comp.ui.storeBackupCodes')}</p>` +
                                        `<p>${this.$t('comp.ui.backupCodeUsageInfo')}</p>`;

                                    view.toggleModal(view.$t('global.ui.success'), text);
                                    view.twofactor = true;
                                    view.loadProfile();
                                    datafill.Toggle();
                                }).catch(function (error) {
                                    datafill.loading = false;
                                    if(error.response != undefined && error.response.data.message != undefined){
                                        view.toggleModal(view.$t('employee.data.error'),
                                            `<p>${view.$t('comp.ui.twoFactorActivationFailed')}</p><p>${view.$t(
                                                'comp.ui.tryAgainOrContactAdmin')}</p>`
                                        );
                                    }
                                })
                            },
                        },
                    }],
                    centered: true,
                });
            },
            OpenDeactivate2FPopup(){
                let view = this;

                this.$helpers.OpenPopup({
                    header: this.$t('comp.ui.deactivate2f'),
                    width: '600px',
                    components: [{
                        type: 'datafill',
                        state: {
                            entries: [
                                {key: 'info', type: 'output', value: this.$t('comp.ui.deactivate2fInfo'), label:'', dataStyles :{'text-align': 'left'}},
                                {key: 'twofactorcode', type: 'text', value: '', placeholder:this.$t('comp.ui.twoFactorCode'), label: ''}],

                            selectCallback: (data, datafill) => {
                                datafill.loading = true;
                                view.deactivateTwoFactor(data.twofactorcode).then(response => {
                                    view.toggleModal(view.$t('global.ui.success'),
                                        `<p>${this.$t('comp.ui.twoFactorDeactivated')}</p>`
                                    );
                                    view.twofactor = false;

                                }).catch(function (error) {
                                    datafill.loading = false;
                                    if(error.response != undefined && error.response.data.message != undefined){
                                        view.toggleModal(view.$t('employee.data.error'),
                                            `<p>${view.$t('comp.ui.twoFactorDeactivationFailed')}</p><p>${view.$t(
                                                'comp.ui.tryAgainOrContactAdmin')}</p>`
                                        );
                                    }
                                })
                            },
                        },
                    }],
                    centered: true,
                });
            },
            RouterToOverview(){
                this.$router.push({name: 'Overview'});
            },
        },
        watch: {
            '$route' (to, from) {
                console.log(to);
                this.id = to.params.id;
                this.token = localStorage.getItem('md_token')
                if(this.isBlank(this.token)){
                    this.returnToIndex();
                } else {
                    this.loadProfile();
                }
            },
            avatar: {
                handler: function() {
                    this.savedImage = false
                },
                deep: true
            }
        },
        computed: {
            buttonStyle () {
                return {
                    flex: `1 1 ${100 / 2}%`
                }
            },
            computedProfileImage() {
                if(this.avatar != null){
                    return this.avatar.imageURL;
                }
                else if(this.isBlank(this.profileimage)){
                    return require("../..//assets/serviceimg/logo.png");
                } else {
                    return this.profileimage.url;
                }
            }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .profile-panel {
    width: 600px !important;
  }




  .profile-container.card {
    max-width: 100%;
    padding: 40px 40px;
  }
  .profile-user-info {
    display: table;
    width: 98%;
    width: calc(100% - 24px);
    margin: 0 auto
  }

  .profile-info-row {
    display: table-row
  }

  .profile-info-name,
  .profile-info-value {
    display: table-cell;
    border-top: 1px dotted #D5E4F1
  }

  .profile-info-name {
    text-align: right;
    padding: 6px 10px 6px 4px;
    font-weight: 400;
    color: #667E99;
    background-color: transparent;
    width: 110px;
    vertical-align: middle
  }

  .profile-info-value {
    padding: 6px 4px 6px 6px
  }

  .profile-info-value>span+span:before {
    display: inline;
    content: ",";
    margin-left: 1px;
    margin-right: 3px;
    color: #666;
    border-bottom: 1px solid #FFF
  }

  .profile-info-value>span+span.editable-container:before {
    display: none
  }

  .profile-info-row:first-child .profile-info-name,
  .profile-info-row:first-child .profile-info-value {
    border-top: none
  }

  .profile-user-info-striped {
    border: 1px solid #DCEBF7
  }

  .profile-user-info-striped .profile-info-name {
    color: #336199;
    background-color: #EDF3F4;
    border-top: 1px solid #F7FBFF
  }

  .profile-user-info-striped .profile-info-value {
    border-top: 1px dotted #DCEBF7;
    padding-left: 12px
  }

  .link-container{
    text-align: center;
    bottom: 25px;

    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    white-space: nowrap;
  }

  .link-container img{
    cursor: pointer;
    width: 96px;
    height: 96px;
    margin: 0 12px;
  }

  .link-container img.mp{
    cursor: pointer;
    width: 102px;
    height: 102px;
    margin: 0 10px;
  }

  .footer{
    margin-bottom: 96px;
    padding-top: 25px;
  }
</style>
